import { IndeterminateCheckBoxSharp } from '@mui/icons-material'
import {
  Icon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import React, { useMemo, useRef } from 'react'
import { useTable, useSortBy } from 'react-table'

const CustomSortTable = ({
  data,
  column,
  nav,
  onClick,
  sx,
  sxHeader,
  sxCell,
  sxNav,
  stickyHeader,

  //   additional functionality
  selectedRow,
  setSelectedRow,
  isRowSelectable = () => true,

  ...rest
}) => {
  const checkboxRef = useRef()
  const selectableData = data.filter(isRowSelectable)
  const tableHeader = useMemo(() => column, [column])
  const tableInstance = useTable(
    {
      columns: tableHeader,
      data: data,
    },
    useSortBy
  )
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRow(selectableData)
      return
    }
    setSelectedRow([])
  }

  return (
    <TableContainer
      className="scrollbar"
      sx={{
        backgroundColor: 'white.main',
        boxShadow: 'none',
        '& th.MuiTableCell-root': {},
        '& td.MuiTableCell-root': {
          padding: '0px',
        },
        ...sx,
      }}
      {...rest}
    >
      <Table stickyHeader={stickyHeader} {...getTableProps}>
        <TableHead>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()} sx={{ zIndex: 10 }}>
              {headerGroup.headers.map((column, index) => {
                return (
                  <TableCell
                    align="center"
                    {...column.getHeaderProps(!column.checkbox && column.getSortByToggleProps())}
                    padding={column.checkbox ? 'checkbox' : 'normal'}
                    sx={{ zIndex: 10 }}
                  >
                    {column.checkbox ? (
                      <>
                        {selectedRow.length < selectableData.length && selectedRow.length !== 0 ? (
                          <AdxCheckbox
                            checked
                            onChange={() => setSelectedRow([])}
                            checkedIcon={<IndeterminateCheckBoxSharp />}
                          />
                        ) : (
                          <AdxCheckbox
                            onChange={handleSelectAll}
                            checked={
                              selectedRow.length === selectableData.length &&
                              selectableData.length !== 0
                            }
                            disabled={selectableData.length === 0}
                          />
                        )}
                      </>
                    ) : (
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: 'light-gray-text.main',
                          display: 'flex',
                          alignItems: 'center',
                          textAlign: 'start',
                          justifyContent: 'space-between',
                          ...sxHeader,
                        }}
                      >
                        {column.render('Header')}
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>
                              arrow_drop_up
                            </Icon>
                          ) : (
                            <Icon sx={{ fontSize: '32px', color: 'alternate.main' }}>
                              arrow_drop_down
                            </Icon>
                          )
                        ) : (
                          <Icon
                            sx={{
                              fontSize: '32px',
                              color: 'gray-inactive-button.main',
                            }}
                          >
                            arrow_drop_down
                          </Icon>
                        )}
                      </Typography>
                    )}
                  </TableCell>
                )
              })}
              {nav && (
                <TableCell>
                  <Typography></Typography>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row)

            return (
              <TableRow {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  return (
                    <TableCell align="center" {...cell.getCellProps()} sx={{ cursor: 'pointer' }}>
                      {cell.column.checkbox ? (
                        <AdxCheckbox
                          ref={checkboxRef}
                          checked={selectedRow.includes(row.original)}
                          disabled={!isRowSelectable(row.original)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedRow([...selectedRow, row.original])
                            } else {
                              const filteredItem = selectedRow.filter(
                                (item) => item !== row.original
                              )
                              setSelectedRow(filteredItem)
                            }
                          }}
                        />
                      ) : (
                        <Typography
                          sx={{
                            textAlign: index === 0 && 'left',
                            p: 2,
                            ...sxCell,
                          }}
                          onClick={() => {
                            if (!isRowSelectable(row.original)) return
                            if (selectedRow.includes(row.original)) {
                              const filteredItem = selectedRow.filter(
                                (item) => item !== row.original
                              )
                              setSelectedRow(filteredItem)
                            } else {
                              setSelectedRow([...selectedRow, row.original])
                            }
                          }}
                        >
                          {cell.render('Cell')}
                        </Typography>
                      )}
                    </TableCell>
                  )
                })}
                {nav && (
                  <TableCell align="right">
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: 'alternate.main',
                        cursor: 'pointer',
                        padding: '18px 30px',
                        ...sxNav,
                      }}
                      onClick={() => onClick(row.original)}
                    >
                      {nav}
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CustomSortTable
